import { CAL_EVENT_MAX_TAGS } from '../../events/cal-event-max-tags.js';
import { CHECK_IN_ASSIGNEE_REQUIRED_MESSAGE } from '../../events/check-in-assignee-required-message.js';
import { hasCheckInGate } from '../../events/has-check-in-gate.js';
import { isStagedTagKey } from '../../events/is-staged-tag-key.js';
import { stagedTagKey } from '../../events/staged-tag-key.js';
export function refineTemplateSettings(data, context) {
    if (data.tagIds.length + data.newTags.length > CAL_EVENT_MAX_TAGS) {
        context.addIssue({
            code: 'custom',
            message: `A template can have at most ${CAL_EVENT_MAX_TAGS} tags.`,
            path: ['tagIds'],
        });
    }
    const stagedKeys = new Set(data.newTags.map((tag) => stagedTagKey(tag.name)));
    data.rules?.forEach((rule, index) => {
        if (rule.type === 'addTagIf' &&
            isStagedTagKey(rule.targetFieldId) &&
            !stagedKeys.has(rule.targetFieldId)) {
            context.addIssue({
                code: 'custom',
                message: 'A rule adds a tag that is not on this template.',
                path: ['rules', index],
            });
        }
    });
    if (data.presetPromotionId && data.promoMode === 'none') {
        context.addIssue({
            code: 'custom',
            message: 'A preset promotion needs promotion mode Optional or Required.',
            path: ['presetPromotionId'],
        });
    }
    if (data.promoLocked && !data.presetPromotionId) {
        context.addIssue({
            code: 'custom',
            message: 'Locking the promotion needs a preset promotion.',
            path: ['promoLocked'],
        });
    }
    if (hasCheckInGate(data.checkInRequired, data.rules) && data.assigneeMode === 'none') {
        context.addIssue({
            code: 'custom',
            message: CHECK_IN_ASSIGNEE_REQUIRED_MESSAGE,
            path: [data.checkInRequired ? 'checkInRequired' : 'assigneeMode'],
        });
    }
}
//# sourceMappingURL=refine-template-settings.js.map